import React, { useState, useEffect } from 'react'
import { EditorState, ContentState } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';

import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

export default function EditorHTML (params) {
  const [editorState, setEditorState] = useState(EditorState.createEmpty())
  useEffect(() => {
    console.log(params.content)
    if(params.content) {
      const contentBlock = htmlToDraft(params.content);
      const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
      const editorState = EditorState.createWithContent(contentState);
      setEditorState(editorState)
    }
  }, [])

  return (
    <Editor
        editorState={editorState}
        toolbarClassName="toolbarClassName"
        wrapperClassName="wrapperClassName"
        editorClassName="editorClassName"
        onChange={(e) => {
          params.setContent(params.field, draftToHtml(e))
        }}
        onEditorStateChange={setEditorState}
      />
  )

}